import React from "react";
import { List, Modal } from "antd";
import { toArray } from "../util";

export function ModalListProcessFlowChart({ selectedViewer, processList, updateProcessList, loadProcess }) {
    return (
        <Modal
            title="Selecione processo"
            visible={true}
            footer={false}
            onCancel={() => updateProcessList(null)}
            width="250px"
        >
            <List
                header={null}
                footer={null}
                bordered={false}
                size="small"
                dataSource={toArray(processList)}
                renderItem={(item) => (
                    <List.Item
                        actions={[
                            <a
                                href="!#"
                                key="process-load"
                                onClick={(e) => {
                                    e.preventDefault();
                                    // const view = appState.selectedViewer;
                                    const view = selectedViewer;

                                    loadProcess({
                                        action: "consult",
                                        process: item.process,
                                        task: item?.tasks[0],
                                        forceView: view,
                                    });
                                    updateProcessList(null);
                                }}
                            >
                                Carregar
                            </a>,
                        ]}
                    >
                        {item.process}
                    </List.Item>
                )}
            />
        </Modal>
    );
}
